import { FC, useState } from 'react';

import ConfirmationModal from 'dashboard/components-lib/ConfirmationModal';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface WorkflowDeactivateModalProps {
  workflowName?: string;
  handleClose: () => void;
  handleConfirm: () => void;
}

const WorkflowDeactivateModal: FC<WorkflowDeactivateModalProps> = ({
  workflowName = 'Workflow',
  handleClose,
  handleConfirm,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return (
    <ConfirmationModal
      cancelAction={handleClose}
      confirmAction={handleConfirm}
      header='Deactivate this workflow?'
      confirmActionText='Deactivate'
      confirmButtonType='danger'
      allowConfirm={inputValue === workflowName}
      data-test='workflow-deactivate-modal'
    >
      <Paragraph>
        <strong>{workflowName}</strong> will be deactivated. This affects all environments. To
        deactivate Workflows in individual environments, click into the Workflow and leverage the
        configuration or publish modals.
      </Paragraph>
      <br />
      <Paragraph>
        Please type <strong>{workflowName}</strong> to confirm:
      </Paragraph>
      <Spacer height={2} />
      <Input
        id='workflow-name-input'
        value={inputValue}
        onChange={handleInputChange}
        role='textbox'
      />
    </ConfirmationModal>
  );
};

export default WorkflowDeactivateModal;
